// TODO $.richtext()
// Police => ajouter l'option (Par défaut) pour annuler ce style
// Taille => ajouter (Par défaut) pour annuler ce style
// Couleur du texte => "Automatique" / 4*6 / "Plus de couleurs"
// Couleur d'arrière-plan => "Automatique" / 4*6 / "Plus de couleurs"

window.RichText = (function($, BaseAPI) {
	"use strict";

	function RichText(target, options) {
		this.options = $.extend({}, RichText.defaultOptions, options);
		this.target = $(target).wrap('<div />').hide();
		this.container = this.target.parent()
			.addClass('bbm-richtext')
			.toggleClass('bbm-richtext-border', this.options.border)
			.toggleClass('bbm-richtext-flex', this.options.flex)
			.css('background-color', this.options.backgroundColor);
		this.toolbar = $('<div />').prependTo(this.container);
		this.editor = $('<div contenteditable="true" />')
			.css('font-family', this.options.defaultFontFamily)
			.css('font-size', this.options.defaultFontSize)
			.on('paste', this.doPaste.bind(this))
			.on('mousedown keydown', this.checkSelectionStyle.bind(this))
			.on('keydown', this.checkKeystroke.bind(this))
			.html(this.target.val())
			.appendTo(this.container);
		this.lastSelectionStyleNode = null; // voir RichText.prototype.checkSelectionStyle
		if (this.options.autoSave)
			this.editor.on('input', this.save.bind(this));

		this.addCommandButton('Supprimer le formatage', 'format_clear', null, 'removeFormat');
		this.addSeparator();
		this.fontFamily = this.addSelect('Police de caractères', '132px', RichText.fontFamilyOptions(this.options.defaultFontFamily), function(fontFamily) {
			document.execCommand('fontName', null, fontFamily);
		});
		this.fontSize = this.addSelect('Taille du texte', '40px', RichText.fontSizeOptions(this.options.defaultFontSize), function(fontSize) {
			// Idée trouvée ici : https://stackoverflow.com/questions/5868295/document-execcommand-fontsize-in-pixels
			// Ne fonctionne pas si on appelle : document.execCommand('styleWithCSS', null, true); D'où l'appel avec "false" pour être sûr
			document.execCommand('fontSize', false, 7);
			$(target).parent().find('font[size=7]').removeAttr('size').css('font-size', fontSize);
		});
		this.addSeparator();
		this.addCommandButton('Gras (Ctrl+B)', 'format_bold', null, 'bold'); // <b>B</b>
		this.addCommandButton('Italique (Ctrl+I)', 'format_italic', null, 'italic'); // <i>I</i>
		this.addCommandButton('Souligné (Ctrl+U)', 'format_underlined', null, 'underline'); // <u>U</u>
		this.addCommandButton('Barré (Ctrl+!)', 'format_strikethrough', null, 'strikeThrough'); // <s>S</s>
		this.addSeparator();
		this.addCommandButton('Aligné à gauche', 'format_align_left', null, 'justifyLeft');
		this.addCommandButton('Centré', 'format_align_center', null, 'justifyCenter');
		this.addCommandButton('Aligné à droite', 'format_align_right', null, 'justifyRight');
		this.addCommandButton('Justifié', 'format_align_justify', null, 'justifyFull');
		this.addSeparator();
		this.addColorSelection('format_color_text', 'Dernière couleur du texte', 'Choisir la couleur du texte', 'foreColor', '#000000', function(group, color) {
			group.find('.material-icons').css('color', color);
		});
		this.addColorSelection('format_color_fill', 'Dernière couleur de remplissage', 'Choisir la couleur de remplissage', 'backColor', '#FFFF00', function(group, color) {
			group.children().css('background-color', color);
		});
		this.addSeparator();
		this.addButton('Plus de contrôles', 'more_vert').addClass('more').click(this.doMoreOrLess.bind(this));
		this.addSeparator();
		this.addCommandButton('Liste à puce', 'format_list_bulleted', null, 'insertUnorderedList');
		this.addCommandButton('Liste numérotée',  'format_list_numbered', null, 'insertOrderedList');
		this.addCommandButton('Diminuer le retrait (Shift+Tab)', 'format_indent_decrease', null, 'outdent');
		this.addCommandButton('Augmenter le retrait (Tab)', 'format_indent_increase', null, 'indent');
		this.addCommandButton('Citation', 'format_quote', null, 'formatBlock', 'BLOCKQUOTE');
		this.addCommandButton('Indice', null, 'x<sub>2</sub>', 'subscript');
		this.addCommandButton('Exposant', null, 'x<sup>2</sup>', 'superscript');
		this.addCommandButton('Diminuer la taille du texte', null, 'A<small>A</small>', 'decreaseFontSize');
		this.addCommandButton('Augmenter la taille du texte', null, '<small>A</small>A', 'increaseFontSize');
		this.addSeparator();
		this.addPromptButton('Insérer un lien (Ctrl+K)', 'link', 'createLink', 'URL du lien', 'https://');
		this.addCommandButton('Supprimer le lien', 'link_off', null, 'unlink');
		this.addPromptButton('Insérer une image', 'image', 'insertImage', 'Image', 'https://dummyimage.com/160x90');
		this.addPromptButton('Insérer un tableau', 'grid_on'/* ou border_all */, 'insertHTML', 'Tableau', '<table class="table table-bordered"><tr><td></td><td></td><td></td></tr><tr><td></td><td></td><td></td></tr><tr><td></td><td></td><td></td></tr></table>');
		this.addCommandButton('Insérer une ligne horizontale', 'vertical_align_center'/* ou remove */, null, 'insertHorizontalRule');
		this.addButton('Insérer un caractère spécial', 'functions').css('background-color', 'orange');
		this.addButton('Insérer un émoticône', 'insert_emoticon').css('background-color', 'orange');
		this.addSeparator();
		this.addButton('Voir le source', 'code').click(this.doSource.bind(this));
		this.addButton('Maximiser', 'fullscreen').click(this.doMaximize.bind(this));
		this.addButton('Imprimer', 'print').click(this.doPrint.bind(this));
	
		// s'assurer que "styleWithCSS" est bien à faux. Sinon, le choix de la taille de police ne fonctionne pas sous Chrome
		document.execCommand('styleWithCSS', null, false);
		// les flèches pour ajouter et la croix pour supprimer des lignes et des colonnes dans les tableaux
		document.execCommand('enableInlineTableEditing', null, true);
		// les carrés pour changer les dimensions des éléments, comme des tableaux ou des images
		document.execCommand('enableObjectResizing', null, true);
		// toolbar réduite par défaut
		this.toolbar.find('.more').nextAll().hide();
	}

	RichText.prototype.save = function() {
		this.target.val(this.editor.html()).change();
	};

	RichText.prototype.checkSelectionStyle = function(event) {
		var self = this;
		$(document.body).one('mouseup keyup', function(event) {
			var s = document.getSelection();
			var e = s.focusNode || s.anchorNode;
			while (! e.style)
				e = e.parentNode;
			if (self.lastSelectionStyleNode === e)
				return;
			self.lastSelectionStyleNode = e;
			if (self.editor.find(e).length === 1) {
				var style = window.getComputedStyle(e);
				self.fontFamily.children('button').text(style.fontFamily);
				self.fontSize.children('button').text('' + parseInt(style.fontSize));
			}
		});
	};

	RichText.prototype.checkKeystroke = function(event) {
		var key = event.key || '';
		var ctrlOnly = event.ctrlKey && !event.altKey && !event.metaKey && !event.shiftKey;
		var preventDefault = true;
		if (key === 'Tab')
			document.execCommand(event.shiftKey ? 'outdent' : 'indent');
		else if (ctrlOnly && key === 'b')
			document.execCommand('bold');
		else if (ctrlOnly && key === 'i')
			document.execCommand('italic');
		else if (ctrlOnly && key === 'u')
			document.execCommand('underline');
		else if (ctrlOnly && key === '!')
			document.execCommand('strikeThrough');
		else if (ctrlOnly && key === 'k') {
			var params = window.prompt('URL du lien', 'https://');
			if (params !== null)
				document.execCommand('createLink', null, params);
		} else if (ctrlOnly && key === 's')
			this.save();
		else
			preventDefault = false;
		if (preventDefault)
			event.preventDefault();
	};

	RichText.prototype.doPaste = function(event) {
		// On bloque l'évènement "paste" pour insérer l'HTML ou le texte nous-même.
		if (this.options.pasteAsHTML) {
			var html = event.originalEvent.clipboardData.getData('text/html');
			if (html) {
				document.execCommand('insertHTML', null, this.options.sanitize(html));
				event.preventDefault();
			}
		} else {
			var text = event.originalEvent.clipboardData.getData('text/plain');
			if (text) {
				document.execCommand('insertText', null, text);
				event.preventDefault();
			}
		}
	};
	
	RichText.prototype.doMoreOrLess = function(event) {
		var button = $(event.target).closest('button').toggleClass('active');
		button.children().text(button.is('.active') ? 'more_horiz' : 'more_vert');
		button.nextAll().toggle();
	};
	
	RichText.prototype.doSource = function(event) {
		var button = $(event.target).closest('button');
		if (this.target.is(':visible')) {
			this.target.hide();
			this.editor.html(this.target.val()).show();
			button.siblings().show();
		} else {
			this.editor.hide();
			this.target.val(this.editor.html()).show();
			button.siblings().hide();
		}
	};
	
	RichText.prototype.doMaximize = function(event) {
		var icon = $(event.target).closest('button').find('i');
		this.container.toggleClass('maximized');
		if (this.container.hasClass('maximized')) {
			var fullscreenElement = this.container[0];
			fullscreenElement.requestFullscreen = fullscreenElement.requestFullscreen || fullscreenElement.mozRequestFullScreen || fullscreenElement.webkitRequestFullscreen || fullscreenElement.msRequestFullscreen;
			fullscreenElement.requestFullscreen();
			icon.text('fullscreen_exit');
		} else {
			document.exitFullscreen = document.exitFullscreen || document.mozCancelFullScreen || document.webkitExitFullscreen || document.msExitFullscreen;
			document.exitFullscreen();
			icon.text('fullscreen');
		}
	};
	
	RichText.prototype.doPrint = function(event) {
		var w = window.open('', 'Imprimer', '');
		w.document.write(''
				+ '<html>'
				+ '  <head>' + $('head').html() + '</head>'
				+ '  <body>'
				+ '    <div style="font-family:' + this.options.defaultFontFamily + '; font-size:' + this.options.defaultFontSize + '; ">'
				+ '      ' + this.editor.html()
				+ '    </div>'
				+ '  </body>'
				+ '</html>');
		w.document.close();
	};
	
	/**
	 * Cette méthode ajoute un bouton liée à la commande "command", non par pour l'exécuter,
	 * mais pour désactiver le bouton si la commande n'est pas supportée.
	 */
	RichText.prototype.addButton = function(title, icon, html, command) {
		var e = $('<button type="button" class="btn btn-link btn-sm" />');
		e.attr('title', title);
		if (icon)
			e.append('<i class="material-icons">' + icon + '</i>');
		if (html)
			e.append(html);
		if (command && !document.queryCommandSupported(command))
			e.prop('disabled', true);
		return e.appendTo(this.toolbar);
	};
	
	/**
	 * Cette méthode ajoute un bouton qui exécutera la commande "command" quand on clique dessus.
	 * Le bouton peut être personnalisé avec un titre et un icone et/ou un texte.
	 * Eventuellement, on peut préciser les paramètres "params" utilisés pour éxécuter la commande.
	 */
	RichText.prototype.addCommandButton = function(title, icon, html, command, params) {
		if (document.queryCommandSupported(command))
			this.addButton(title, icon, html, command).click(function() {
				document.execCommand(command, null, params);
			});
	};
	
	/**
	 * Cette méthode ajoute un bouton qui demandera une valeur textuelle à l'utilisateur.
	 * Si l'utilisateur répond et confirme, la commande "command" est exécutée avec la valeur en paramètre.
	 */
	RichText.prototype.addPromptButton = function(title, icon, command, promptTitle, defaultValue) {
		if (document.queryCommandSupported(command))
			this.addButton(title, icon, null, command).click(function() {
				var params = window.prompt(promptTitle, defaultValue);
				if (params !== null)
					document.execCommand(command, null, params);
			});
	};
	
	/**
	 * Cette méthode ajoute 2 boutons permettant de sélectionner une couleur puis de la réutiliser facilement.
	 * L'impact dans l'éditeur de "command" est géré dans cette fonction (foreColor ou backColor).
	 * Par contre, le changement visuel dans la barre d'outil est délégué à "callback" (color ou background-color).
	 */
	RichText.prototype.addColorSelection = function(icon, title, selectTitle, command, defaultColor, callback) {
		var group = $('<div class="btn-group"></div>').appendTo(this.toolbar);
		var button = this.addButton(title, icon, null, command).appendTo(group);
		var picker = this.addButton(selectTitle, 'arrow_drop_down', null, command).appendTo(group);
		button.css('padding-right', '2px').click(function(event) {
			var color = group.attr('data-color');
			document.execCommand(command, null, color);
		});
		picker.css('padding-left', '2px').colorpicker({
			color: defaultColor,
		}).on('changeColor', function(event) {
			var color = event.color.toHex();
			document.execCommand(command, null, color);
			callback(group, color);
			group.attr('data-color', color);
		});
	};
	
	/**
	 * Cette méthode ajoute un menu de sélection dans la barre d'outils.
	 * Le menu est personnalisé par "title", "width" et la liste d'options "options".
	 * A chaque sélection par l'utilisateur, "callback(valeur)" est appelée.
	 */
	RichText.prototype.addSelect = function(title, width, options, callback) {
		var e = $('<div class="dropdown" style="display: inline-block; ">'
				+ '  <button type="button" data-toggle="dropdown" class="btn btn-link btn-sm dropdown-toggle"></button>'
				+ '  <ul class="dropdown-menu"></ul>'
				+ '</div>');
		e.attr('title', title);
		e.children('button').dropdown().css({
			'width': width,
			'overflow': 'hidden',
			'text-overflow': 'ellipsis'
		});
		e.children('ul').append(options.map(function(option) {
			var li = $('<li><a href="#"><span></span><small class="text-muted"></small></a></li>');
			li.attr('data-value', option.value);
			li.find('span').text(option.text);
			if (option.info)
				li.find('small').text(' (' + option.info + ')');
			if (option.isDefault) {
				li.prop('selected', true);
				e.children('button').text(option.text);
			}
			return li[0];
		}));
		e.on('click', '[data-value]', function(event) {
			var li = $(event.target).closest('[data-value]');
			callback(li.attr('data-value'));
			e.children('button').text(li.find('span').text());
			event.preventDefault();
		});
		return e.appendTo(this.toolbar);
	};
	
	/**
	 * Cette méthode ajoute un séparateur dans la barre d'outils.
	 * Il s'agit d'un simple texte " | " pour espacer les boutons de chaque côté.
	 */
	RichText.prototype.addSeparator = function() {
		$('<span>&nbsp;|&nbsp;</span>').appendTo(this.toolbar);
	};

	RichText.parseForDataURL = function(html, upload) {
		var result = $.Deferred(),
			attrPrefix = 'src="',
			dataURLPrefix = 'data:image/',
			si = 0,
			ei = 0,
			dataURL;
	
		// Vérifier si le texte contient des dataURL
		function next() {
			si = html.indexOf(attrPrefix + dataURLPrefix, si + 1);
			if (si === -1) {
				// Plus de dataURL à traiter, c'est fini.
				// Si "ei" est différent de 0, c'est qu'on a fait au moins un remplacement.
				result.resolve(html, ei !== 0);
			} else {
				// On recherche la fin "ei" de l'URL commençant à "si + attrPrefix.length"
				ei = html.indexOf('"', si + attrPrefix.length);
				dataURL = html.substring(si + attrPrefix.length, ei);
				// On appelle la méthode d'uplaod demandée, qui nous retourne une URL en échange
				upload(dataURL, function(resultURL) {
					if (resultURL)
						html = html.replace(dataURL, resultURL);
					next();
				});
			}
		}

		// Let's go !
		next();

		// Return the "Promise"
		return result;
	};

	RichText.defaultOptions = {
		// Permet de nettoyer l'HTML, notamment lors du copier/coller, en utilisant par exemple DOMPurify.sanitize.
		// Par défaut, le texte n'est pas nettoyé mais le collage se fait en texte brut.
		sanitize: function(text) { return text; },
		// Indique si on souhaite coller en HTML (quand c'est possible) ou forcer en texte.
		// Par défaut, le collage se fait en texte brut pour des raisons de sécurité.
		pasteAsHTML: false,
		// Indique si l'on souhaite que l'éditeur s'ajuste à la taille de son parent, en flex, avec la barre fixe en haut.
		// Par défaut, "flex" est actif pour occuper l'expace du parent.
		flex: true,
		// Indique si l'on souhaite que l'éditeur s'entoure d'un trait pour .
		// Par défaut, "border" est actif pour délimiter la zone de saisie et la barre d'outils.
		border: true,
		// Indique si l'on souhaite synchroniser le contenu de la textarea avec le contenu de l'éditeur.
		// Par défaut, ça n'est pas le cas pour des raisons de performances. Il faudra appeler RichText.save().
		autoSave: false,
		// Permet d'ajuster la couleur de fond de l'éditeur si le blanc ne convient pas.
		backgroundColor: 'white',
		// Permet d'ajuster la police de caractères à utiliser comme base pour l'éditeur.
		defaultFontFamily: 'Roboto',
		// Permet d'ajuster la taille du texte à utiliser comme base pour l'éditeur.
		defaultFontSize: '12pt',
	};

	RichText.fontFamilyOptions = function(defaultFontFamily) {
		return [
			{ name: 'Arial', type: 'sans-serif' },
			{ name: 'Calibri', type: 'sans-serif' },
			{ name: 'Century Gothic', type: 'sans-serif' },
			{ name: 'Consolas', type: 'monospace' },
			{ name: 'Courier', type: 'monospace' },
			{ name: 'Courier New', type: 'monospace' },
			{ name: 'DejaVu Sans', type: 'sans-serif' },
			{ name: 'DejaVu Serif', type: 'serif' },
			{ name: 'Garamond', type: 'serif' },
			{ name: 'Helvetica', type: 'sans-serif' },
			{ name: 'Mistral', type: 'cursive' },
			{ name: 'Roboto', type: 'sans-serif' },
			{ name: 'Tahoma', type: 'sans-serif' },
			{ name: 'Times New Roman', type: 'serif' },
			{ name: 'Webdings', type: 'fantasy' }
		].map(function(font) {
			return { value: font.name, text: font.name, info: font.type, isDefault: font.name === defaultFontFamily};
		});
	};

	RichText.fontSizeOptions = function(defaultFontSize) {
		return [8, 9, 10, 11, 12, 14, 16, 18, 20, 22, 24, 26, 28, 36, 48, 72].map(function(size, index, array) {
			var isDefault = size === parseInt(defaultFontSize);
			return {
				value: size + 'pt',
				text: size + '',
				info: (index === 0) ? 'min' : (index === array.length - 1) ? 'max' : isDefault ? 'standard' : '',
				isDefault: isDefault
			};
		});
	};

	if (BaseAPI)
		BaseAPI.registerJQueryPlugin('richtext', RichText);
	return RichText;

})(window.jQuery, window.BaseAPI);
